import React, { createContext, useContext, useEffect, useState } from 'react'
import { useTransition, animated } from '@react-spring/web'
import { Notification } from '@crossfit/ui'

import style from './style.module.css'

type Variant = 'success' | 'info' | 'error' | 'warning'

type NotificationContext = {
  setNotification: (props: { text: string; variant?: Variant } | null) => void
}

const Context = createContext({} as NotificationContext)

type Props = {
  children: React.ReactNode
}

export function NotificationProvider({ children }: Props) {
  const [notification, setNotification] = useState(null)
  const transitions = useTransition(notification, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  useEffect(() => {
    if (notification) {
      setTimeout(() => {
        setNotification(null)
      }, 3000)
    }
  }, [notification])

  return (
    <Context.Provider value={{ setNotification }}>
      {transitions((styles, item) => (
        <animated.div style={styles}>
          {item && (
            <Notification
              className={style.wrapper}
              variant={item.variant}
              onClick={() => setNotification(null)}
              role='log'
              aria-label={item.text}
            >
              {item.text}
            </Notification>
          )}
        </animated.div>
      ))}

      {children}
    </Context.Provider>
  )
}

export function useNotification() {
  const { setNotification } = useContext(Context)

  return (text: string, variant?: Variant) => {
    setNotification({ text, variant })
  }
}
